import { ArrowDown } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { AlpanaDivider, Logo } from "@/components/tss/Ornaments";

const Poster = ({ config }) => {
  const mobile = mediaUrl(config.poster_mobile_url);
  const desktop = mediaUrl(config.poster_desktop_url) || mobile;
  if (!mobile && !desktop) {
    return (
      <div data-testid="hero-placeholder" className="hero-placeholder grain flex aspect-[4/5] w-full flex-col items-center justify-center gap-5 px-8 text-center md:aspect-[21/9]">
        <Logo url={config.logo_url} size={72} />
        <h1 className="gold-text font-display text-4xl font-extrabold leading-tight sm:text-5xl lg:text-6xl">{config.hero_title}</h1>
        <p className="font-bengali text-lg text-ivory/90">শারদ সম্মান · জনতার পছন্দ</p>
      </div>
    );
  }
  return (
    <picture data-testid="hero-poster">
      {desktop && <source media="(min-width: 768px)" srcSet={desktop} />}
      <img src={mobile || desktop} alt={config.hero_title} className="block h-auto w-full md:max-h-[78vh] md:object-cover" />
    </picture>
  );
};

export const Hero = ({ config, onStart, showStart = true }) => (
  <header className="relative bg-maroon-deep">
    <Poster config={config} />
    <div className="grain relative bg-maroon px-5 pb-8 pt-7 text-ivory md:px-10">
      <div className="mx-auto max-w-3xl rise">
        <div data-testid="public-voting-banner" className="mb-5 inline-flex flex-col rounded-2xl border-2 border-gold bg-maroon-deep/60 px-5 py-3 shadow-festive">
          <span className="gold-text font-display text-3xl font-extrabold uppercase leading-none tracking-wide sm:text-4xl">Public Voting</span>
          <span className="mt-1.5 font-bengali text-lg font-semibold text-ivory">জনতার ভোট · People's Choice</span>
        </div>
        <div className="flex items-center gap-3">
          {config.award_logo_url ? (
            <img src={mediaUrl(config.award_logo_url)} alt="TSS Sharod Shamman logo" data-testid="award-logo" className="h-20 w-20 shrink-0 rounded-full bg-white object-contain p-1 shadow-festive sm:h-24 sm:w-24" />
          ) : (
            <Logo url={config.logo_url} size={48} />
          )}
          <h1 data-testid="hero-title" className="font-display text-[28px] font-bold leading-tight sm:text-4xl">{config.hero_title}</h1>
        </div>
        {config.hero_subtitle && <p data-testid="hero-subtitle" className="mt-4 text-[15px] leading-relaxed text-ivory/85">{config.hero_subtitle}</p>}
        <p className="mt-2 text-sm text-ivory/70">Pick your favourite puja in each category. Skip any you haven't seen — one tap is one pick.</p>
        <AlpanaDivider className="mt-6" />
        {showStart && (
          <button
            type="button"
            data-testid="start-voting-btn"
            onClick={onStart}
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 font-semibold text-maroon-deep shadow-festive transition-[transform,background-color] duration-200 hover:bg-gold-light active:scale-95"
          >
            Start voting <ArrowDown className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  </header>
);
